import { clearInput } from "../framework/components/omnisearch";

const hook = {
  mounted() {
    // Petronille ai is displayed indiscriminately on most pages.
    // to avoid overloading the server with configuration, assigns and options
    // we infer the context from the URL after mounting
    const context = inferContextFromUrl();
    this.pushEvent("petronille-ai-context", { context: context });

    window.addEventListener("refresh-page", () => {
      window.location.reload();
    });

    this.el.addEventListener("start-conversation-from-omnisearch", (event) => {
      const inputElId = event.detail.inputElId;
      const inputEl = document.getElementById(inputElId);
      const message = inputEl.value;
      clearInput(inputEl);
      this.pushEvent("start-conversation", { message: message });
    });
  },
};

const inferContextFromUrl = () => {
  const path = window.location.pathname;

  const context = [
    ["training_session_id", /^\/training_sessions\/(\d+)/],
    ["instructor_id", /^\/instructors\/(\d+)/],
    ["room_id", /^\/rooms\/(\d+)/],
    ["trainee_id", /^\/trainees\/(\d+)/],
    ["company_id", /^\/companies\/(\d+)/],
    ["program_id", /^\/programs\/(\d+)/],
  ].reduce((acc, [key, regex]) => {
    const match = path.match(regex);
    if (match) {
      acc[key] = parseInt(match[1], 10);
    }
    return acc;
  }, {});

  return context;
};

export default hook;
